import get from 'lodash/fp/get';
import pipe from 'lodash/fp/pipe';
import isEmpty from 'lodash/fp/isEmpty';
import moment from 'moment';
import { formatAddress } from '../utils/helpers';
import config from '../../config';

export const getCampaignLoading = get('campaign.loading');

export const getCampaign = get('campaign.item');

export const getCampaignLogo = pipe(getCampaign, get('logo.url'));

export const getCampaignShopName = pipe(getCampaign, get('shop.name'));

export const getCampaignShopAddress = pipe(getCampaign, get('shop.address'), formatAddress);

export const getCampaignBackgroundImage = pipe(getCampaign, get('background.url'));

export const getCampaignColor = pipe(getCampaign, get('color'));

export const getCampaignSubject = pipe(getCampaign, get('subject'));

export const getCampaignBody = pipe(getCampaign, get('body'));

export const getCampaignUnsubscribeUrl = pipe(getCampaign, get('unsubscribeUrl'));

export const getCampaignShop = pipe(getCampaign, get('shop'));

const transformPromo = (promo) => {
  if (isEmpty(promo)) return {};
  return {
    ...promo,
    expirationDate:
      promo.expirationDate && moment(promo.expirationDate, config.apiDateFormat).format(config.apiDateFormat),
  };
};

export const getCampaignPromo = pipe(getCampaign, get('promo'), transformPromo);

export const getCampaignBookUrl = pipe(getCampaign, get('bookingUrl'), url => (url || ''));



// WEBPACK FOOTER //
// ./src/app/campaign/selectors.js